import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

class ProgressBar extends Component {
    render() {
        const { progressBar } = this.props
        if (!progressBar.active) return (<div></div>)
        return (
            <div id='progress-bar'>
                <div className='progress' style={ { width: `${progressBar.percent}%` } }></div>
            </div>
        )
    }
}

ProgressBar.propTypes = {
    progressBar: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    const { progressBar } = state
    return {
        progressBar
    }
}

export default connect(mapStateToProps)(ProgressBar)


// WEBPACK FOOTER //
// ./src/client/features/progressBar/components/ProgressBar.jsx